export default __webpack_public_path__ + "static/5-3-0-0-83dd42ce442936f5e940c3ef6f3782b0.jpg";